import { FC } from 'react';
import { Text } from '@epam/promo';
import css from './UserGroupEditModal.module.scss';

export const RulesHint: FC = () => (
  <div className={css.additionalText}>
    <Text cx={css.additionalText}>
      To add more than one user role, separate each one with a comma
    </Text>
    <Text cx={css.additionalText}>
      Example: <strong>Developer, Business Analyst, DevOps Engineer</strong>
    </Text>
  </div>
);
